import { render } from "./Erro.vue?vue&type=template&id=44ff8fda"
const script = {}
script.render = render

export default script